module.exports = __webpack_public_path__ + "img/积分兑换.9696a473.svg";